import script from "./insertPlan.vue?vue&type=script&setup=true&lang=ts"
export * from "./insertPlan.vue?vue&type=script&setup=true&lang=ts"

import "./insertPlan.vue?vue&type=style&index=0&id=5fb784b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fb784b3"]])

export default __exports__